
import React, { Component } from 'react';
import ImageSlider from '../components/Gallery/ImageSlider';
import ImageDataService from '../services/ImageDataService';
import AuthService from '../services/AuthService';
import AlbumDataService from '../services/AlbumDataService';
import Login from './Login';

class Gallery extends Component {
  state = {
    selectedFile: null,
    imagesOfAlbum: [],
    authorized: false,
    haveRoleOfAdminOrMod: false,
    albums: []
  }

  componentDidMount() {
    this.refreshAlbums();

  }

  refreshAlbums = () => {
    const loggedInUser = AuthService.getCurrentUser();
    const whatRole = AuthService.getUserRole();
    if (!loggedInUser || (whatRole === ('USER'))) { } else {
      this.setState({ authorized: true })
      if (whatRole === ('MODERATOR') || whatRole === ('ADMIN')) {
        this.setState({ haveRoleOfAdminOrMod: true });
      }
      AlbumDataService.getAllAlbums()
        .then(res => {
          const albums = res.data;
          this.setState({ albums });
        })
    }
  }






  fileSelectedHandler = event => {
    this.setState({
      selectedFile: event.target.files[0]
    })
  }

  fileUploadHandler = () => {
    const formData = new FormData();
    formData.append('file', this.state.selectedFile);
    ImageDataService.uploadImage(formData);
  }

  handleSelectorCollectionAlbum(collection) {
    AlbumDataService.getAllAlbumImages(collection.id)
      .then(res => {
        const imagesOfAlbum = res.data;
        this.setState({ imagesOfAlbum });
  
      })
    // this.setState({selectedAlbum : collection})

  }

  render() {
    return (
      <div className="wrapper-image-gallery">
        {!this.state.authorized ?
          <div>
            <Login></Login>
          </div> : 
       <div className="buttons-gallery-selector">
      {this.state.albums.map(album => (
        
<button className="btn" key={album.id} onClick = {() => this.handleSelectorCollectionAlbum(album)}>{album.name}</button>
 
      ))}
       
      </div> }
      {this.state.authorized &&  <ImageSlider slides={this.state.imagesOfAlbum} />}
    </div>
    );
  }
};

export default Gallery;
